'use client'

import React from 'react'
import Image from 'next/image'

export function MeetYourDoulaSection() {
  const profiles = [
    {
      name: 'Ruby Daniel',
      role: 'Labor Support & Postpartum Doula',
      image: '/images/ruby-daniel.jpeg',
    },
    {
      name: 'Rhona Moore',
      role: 'Postpartum Doula & Overnight Newborn Specialist',
      image: '/images/rhona-moore.jpg',
    },
    {
      name: 'Janina Shorter',
      role: 'Labor Support Doula',
      image: '/images/janina-shorter.jpg',
    },
    {
      name: 'Sonrisa Parker',
      role: 'Lactation Consultant',
      image: '/images/sonrisa-parker.jpg',
    },
  ]

  return (
    <section
      data-component-name="MeetYourDoulaSection"
      className="relative"
      style={{
        backgroundColor: 'rgb(58, 78, 61)',
        padding: '290px 0 100px',
        marginTop: '-192px',
        position: 'relative',
        zIndex: 10,
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Subtitle */}
          <h5
            style={{
              fontSize: '20px',
              fontFamily: 'var(--font-sulsans-medium)',
              fontWeight: '400',
              color: 'rgb(206, 255, 164)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              marginBottom: '0px',
            }}
          >
            OUR COMMUNITY
          </h5>

          {/* Main Heading */}
          <h2
            style={{
              fontSize: '49px',
              fontFamily: 'var(--font-copernicus)',
              fontWeight: '400',
              color: 'rgb(255, 255, 255)',
              letterSpacing: '-1px',
              marginBottom: '20px',
              marginTop: '10px',
            }}
          >
            Meet your Doula
          </h2>

          {/* Description */}
          <p
            style={{
              fontSize: '15px',
              fontFamily: 'var(--font-sulsans-light)',
              fontWeight: '400',
              color: 'rgb(255, 255, 255)',
              lineHeight: '22px',
              maxWidth: '900px',
              margin: '0 auto 40px',
            }}
          >
            Okkanti includes an intelligent search tool that helps you find your Circle of Support
            when you&apos;re pregnant or parenting. Finding care covered by your insurance? Looking
            for someone to help you sleep tonight? Stop &apos;calling around&apos; and find your
            options in one convenient, trusted place. We&apos;ve aggregated the available supports
            and services in your community so that you can find your &apos;We&apos;re ok!&quot;
            today.
          </p>

          {/* Get Matched Button */}
          <a
            href="https://app.okkanti.com/search"
            style={{
              display: 'inline-block',
              fontSize: '15px',
              fontFamily: 'var(--font-copernicus)',
              fontWeight: '400',
              color: 'rgb(58, 78, 61)',
              backgroundColor: 'rgb(206, 255, 164)',
              padding: '20px 40px',
              borderRadius: '40px',
              border: 'none',
              textDecoration: 'none',
              marginBottom: '60px',
              transition: 'transform 0.3s, box-shadow 0.3s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)'
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            Get Matched
          </a>

          {/* Doula Profiles Grid */}
          <div
            className="grid grid-cols-2 md:grid-cols-4 gap-8"
            style={{
              marginTop: '60px',
            }}
          >
            {profiles.map((profile, index) => (
              <div key={index} className="text-center">
                {/* Profile Image */}
                <div
                  style={{
                    width: '200px',
                    height: '200px',
                    borderRadius: '50%',
                    margin: '0 auto 20px',
                    overflow: 'hidden',
                  }}
                >
                  <Image
                    src={profile.image}
                    alt={profile.name}
                    width={200}
                    height={200}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div>

                {/* Name */}
                <p
                  style={{
                    fontSize: '20px',
                    fontFamily: 'var(--font-copernicus)',
                    fontWeight: '400',
                    color: 'rgb(255, 255, 255)',
                    marginBottom: '10px',
                  }}
                >
                  {profile.name}
                </p>

                {/* Role */}
                <p
                  style={{
                    fontSize: '15px',
                    fontFamily: 'var(--font-sulsans-light)',
                    fontWeight: '400',
                    color: 'rgb(255, 255, 255)',
                    opacity: 0.9,
                  }}
                >
                  {profile.role}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
